<template>
  <div>
    <ul-form ref="editForm" :model="testForm" :rules="rules" label-width="80px">
      <ul-form-item label="实验名称" prop="title">
        <ul-input v-model="testForm.title" placeholder="请输入实验名称"></ul-input>
      </ul-form-item>
      <ul-form-item label="实验封面" prop="cover">
        <label class="uploading" for="avatar">上传封面</label>
        <input
          v-show="false"
          type="file"
          id="avatar"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event)"
        />
        <span class="hint">建议尺寸：800*450</span>
        <img class="cover" :src="testForm.cover">
      </ul-form-item>
      <ul-form-item label="实验学时" prop="studytime">
        <ul-input
          class="score-input"
          v-model="testForm.studytime"
          placeholder="请输入学时"
          type="number"
        />
        <span class="hint">学时</span>
      </ul-form-item>
      <ul-form-item label="实验地址" prop="url">
        <ul-input v-model="testForm.url" placeholder="请输入实验地址"></ul-input>
      </ul-form-item>
      <div class="hint-url">
        注：实验发布之前，请确保实验已按照平台接口规范完成接入，否则系统将无法采集学生实验成绩。
      </div>
      <div class="link">
        <a :href="require('@/assets/file/virtual.docx')" download="虚拟仿真实验接口规范V1.1.docx">下载平台接口规范文档</a>
      </div>
      <ul-form-item label="实验资源" prop="fileList" v-if="type == 2">
        <file-list :list="testForm.fileList" @update="editFileUpdate"></file-list>
      </ul-form-item>
    </ul-form>
    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import cropper from '../../components/cropper.vue'
import fileList from './fileList.vue'
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: Number,
      default() {
        return 1
      }
    }
  },
  components: {
    cropper,
    fileList
  },
  data() {
    return {
      testForm: {
        title: '',
        cover: '',
        studytime: '',
        url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入实验名称', trigger:"blur" },
          { max: 50, message: '实验名称最多50字', trigger: 'blur' }
        ],
        cover: [
          { required: true, message: '请上传封面', trigger:"blur" },
        ],
        studytime: [
          { required: true, message: '请输入学时', trigger:"blur" },
        ],
        url: [
          { required: true, message: '请输入实验地址', trigger:"blur" },
        ]
      },
    }
  },
  created() {
    this.testForm = this.data
  },
  methods: {
    uploadImg(e) {
      let data = {
        title: '上传封面'
      }
      this.$refs.cropperDialog.uploadImg(e, data)
    },
    upDataPicurl(url) {
      this.testForm.cover = url
    },
    editFileUpdate (list) {
      this.testForm.fileList = list
    }
  }
}
</script>

<style lang="scss" scoped>
.score-input {
  width: 110px;
  margin-right: 10px;
}
.hint {
  color: #969696;
}
.hint-url {
  color: #969696;
  font-size: 12px;
  line-height: 1.5;
  margin: 10px 0;
  padding-left: 80px;
}
.link {
  padding-left: 80px;
  color: #8D77FB;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
}
.uploading {
  color: #8D77FB;
  cursor: pointer;
  margin-right: 12px;
}
.cover {
  display: block;
  width: 120px;
}
</style>